import axios from 'axios'

export const HTTP = axios.create({
  baseURL: '/',
  // baseURL: 'http://localhost:2014/',
  // baseURL: 'http://prod-master:2014/',
  headers: {
    // Authorization: 'Basic ' + credentials
  }
})



// WEBPACK FOOTER //
// ./src/services/HttpService.js